import { Controller } from "@hotwired/stimulus"

// Tracks active section and highlights corresponding TOC link
// Usage: data-controller="scroll-spy"
//        data-scroll-spy-target="link" on TOC links (with data-section-id matching section id)
//        data-scroll-spy-target="section" on content sections (with id attribute)
export default class extends Controller {
  static targets = ["link", "section"]

  connect() {
    this.setupObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupObserver() {
    const options = {
      root: null,
      rootMargin: "-80px 0px -70% 0px",
      threshold: 0
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.setActive(entry.target.id)
        }
      })
    }, options)

    this.sectionTargets.forEach(section => {
      this.observer.observe(section)
    })
  }

  setActive(sectionId) {
    this.linkTargets.forEach(link => {
      if (link.dataset.sectionId === sectionId) {
        link.classList.remove("text-gray-500", "hover:text-navy-700")
        link.classList.add("text-teal-600", "font-semibold", "border-l-2", "border-teal-500")
      } else {
        link.classList.remove("text-teal-600", "font-semibold", "border-l-2", "border-teal-500")
        link.classList.add("text-gray-500", "hover:text-navy-700")
      }
    })
  }
}
